import { t } from "i18next";
import Image from "next/image";

interface NotFoundProps {
  title?: string;
  description?: string;
  showIcon?: boolean;
  actions?: {
    label: string;
    href: string;
    variant?: "default" | "outline" | "ghost" | "link";
  }[];
}

export default function NotFound({
  title = "Page Not Found",
  description = "Oops! The page you're looking for doesn't exist or has been moved.",
  showIcon = true,
  actions = [
    { label: "visit booking-ai.jp", href: "/", variant: "outline" as const },
  ],
}: NotFoundProps) {
  return (
    <div className="bg-background flex min-h-screen w-full items-center justify-center p-4">
      <div className="max-w-md space-y-6 text-center">
        <div className="space-y-2">
          {showIcon && (
            <h1 className="text-primary text-6xl font-bold tracking-tight">
              404
            </h1>
          )}
          <h2 className="text-2xl font-semibold">{title}</h2>
          <p className="text-muted-foreground">{description}</p>
        </div>
        <div className="flex flex-col justify-center gap-4 pt-4 sm:flex-row">
          <div className="mt-8 border-t border-gray-200 pt-4">
            <div className="flex items-center justify-center space-x-2 text-xs text-gray-500">
              <div className="flex items-center space-x-1">
                <Image
                  src="/assets/app_icon.png"
                  alt="Booking-ai.jp Logo"
                  width={80}
                  height={20}
                  className="object-contain"
                />
              </div>
              <span>| {t("webCall.visit")}: </span>
              <a
                href={process.env.https://app.booking-ai.jp}
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                booking-ai.jp
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
